import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _obj;
/* import __COLOCATED_TEMPLATE__ from './group-manage-email-settings.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import discourseComputed, { on } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./group-manage-email-settings.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend((_dec = on("init"), _dec2 = discourseComputed("emailSettingsValid", "group.smtp_enabled", "group.imap_enabled"), _dec3 = discourseComputed("smtpSettingsValid", "imapSettingsValid", "group.smtp_enabled", "group.imap_enabled"), (_obj = {
  tagName: "",
  dialog: service(),
  imapSettingsValid: false,
  smtpSettingsValid: false,
  _determineSettingsValid() {
    this.set("imapSettingsValid", this.group.imap_enabled && this.group.imap_server);
    this.set("smtpSettingsValid", this.group.smtp_enabled && this.group.smtp_server);
  },
  enableImapSettings(emailSettingsValid, smtpEnabled, imapEnabled) {
    return smtpEnabled && (emailSettingsValid || imapEnabled);
  },
  emailSettingsValid(smtpSettingsValid, imapSettingsValid, smtpEnabled, imapEnabled) {
    return (!smtpEnabled || smtpSettingsValid) && (!imapEnabled || imapSettingsValid);
  },
  _anySmtpFieldsFilled() {
    return [this.group.smtp_server, this.group.smtp_port, this.group.email_username, this.group.email_password].some(value => !isEmpty(value));
  },
  _anyImapFieldsFilled() {
    return [this.group.imap_server, this.group.imap_port].some(value => !isEmpty(value));
  },
  smtpEnabledChange(event) {
    if (!event.target.checked && this.group.smtp_enabled && this._anySmtpFieldsFilled()) {
      this.dialog.confirm({
        message: I18n.t("groups.manage.email.smtp_disable_confirm"),
        didConfirm: () => this.group.set("smtp_enabled", true),
        didCancel: () => this.group.set("imap_enabled", false)
      });
    }
    this.group.set("smtp_enabled", event.target.checked);
  },
  imapEnabledChange(event) {
    if (!event.target.checked && this.group.imap_enabled && this._anyImapFieldsFilled()) {
      this.dialog.confirm({
        message: I18n.t("groups.manage.email.imap_disable_confirm"),
        didConfirm: () => this.group.set("imap_enabled", true)
      });
    }
    this.group.set("imap_enabled", event.target.checked);
  },
  afterSave() {
    // reload the group to get the updated imap_mailboxes
    this.store.find("group", this.group.name).then(() => {
      this._determineSettingsValid();
    });
  }
}, (_applyDecoratedDescriptor(_obj, "_determineSettingsValid", [_dec], Object.getOwnPropertyDescriptor(_obj, "_determineSettingsValid"), _obj), _applyDecoratedDescriptor(_obj, "enableImapSettings", [_dec2], Object.getOwnPropertyDescriptor(_obj, "enableImapSettings"), _obj), _applyDecoratedDescriptor(_obj, "emailSettingsValid", [_dec3], Object.getOwnPropertyDescriptor(_obj, "emailSettingsValid"), _obj), _applyDecoratedDescriptor(_obj, "smtpEnabledChange", [action], Object.getOwnPropertyDescriptor(_obj, "smtpEnabledChange"), _obj), _applyDecoratedDescriptor(_obj, "imapEnabledChange", [action], Object.getOwnPropertyDescriptor(_obj, "imapEnabledChange"), _obj), _applyDecoratedDescriptor(_obj, "afterSave", [action], Object.getOwnPropertyDescriptor(_obj, "afterSave"), _obj)), _obj))));